export enum IotToolbarDispatchActionType {
  ACTIVATE = 'ACTIVATE',
  ADD_ELEMENT = 'ADD_ELEMENT',
  APPLY_DASHBOARD = 'APPLY_DASHBOARD',
  APPLY_FAVORITE_VIEW = 'APPLY_FAVORITE_VIEW',
  APPLY_GRID = 'APPLY_GRID',
  CANCEL = 'CANCEL',
  CONFIGURE = 'CONFIGURE',
  CLEAR_FILTERS_AND_RELOAD_DATA = 'CLEAR_FILTERS_AND_RELOAD_DATA',
  CONFIGURE_PRODUCTS = 'CONFIGURE_PRODUCTS',
  CONFIGURE_SCHEDULER = 'CONFIGURE_SCHEDULER',
  CONFIGURE_VARIABLES_WITH_TEMPLATE = 'CONFIGURE_VARIABLES_WITH_TEMPLATE',
  CREATE_FAVORITE_VIEW = 'CREATE_FAVORITE_VIEW',
  DECOMMISSION = 'DECOMMISSION',
  DELETE_SITE = 'DELETE_SITE',
  DECOMMISSION_DEVICE = 'DECOMMISSION_DEVICE',
  DELETE_DEVICE = 'DELETE_DEVICE',
  DECOMMISSION_ASSET = 'DECOMMISSION_ASSET',
  DELETE_ASSET = 'DELETE_ASSET',
  DELETE_ELEMENT = 'DELETE_ELEMENT',
  DELETE_FAVORITE_VIEW = 'DELETE_FAVORITE_VIEW',
  EDIT_ELEMENT = 'EDIT_ELEMENT',
  EDIT_FAVORITE_VIEW = 'EDIT_FAVORITE_VIEW',
  EDIT_MAINTENANCE = 'EDIT_MAINTENANCE',
  END_MAINTENANCE = 'END_MAINTENANCE',
  EXPORT_DATA = 'EXPORT_DATA',
  DOWNLOAD_CONFIGURATION = 'DOWNLOAD_CONFIGURATION',
  FILTER_TEXT_CHANGE = 'FILTER_TEXT_CHANGE',
  LAUNCH_NOW = 'LAUNCH_NOW',
  MANAGE_GRID_SETTINGS = 'MANAGE_GRID_SETTINGS',
  MOVE_TO = 'MOVE_TO',
  REPLACE = 'REPLACE',
  OPEN_CONNECTOR = 'OPEN_CONNECTOR',
  OPEN_GRID_ADMIN_SETTINGS = 'OPEN_GRID_ADMIN_SETTINGS',
  OPEN_HISTORY = 'OPEN_HISTORY',
  OPEN_MANAGE_PROTOCOLS = 'OPEN_MANAGE_PROTOCOLS',
  OPEN_MANAGE_SUBSCRIBERS = 'OPEN_MANAGE_SUBSCRIBERS',
  OPEN_MASTER_VIEW_ADMIN_SETTINGS = 'OPEN_MASTER_VIEW_ADMIN_SETTINGS',
  REFRESH_PAGE = 'REFRESH',
  REMOVE_PRODUCTS = 'REMOVE_PRODUCTS',
  RESET = 'RESET',
  SAVE = 'SAVE',
  SEND_COMMAND_GET_ALARM = 'SEND_COMMAND_GET_ALARM',
  SEND_COMMAND_GET_CONFIGURATION = 'SEND_COMMAND_GET_CONFIGURATION',
  SEND_COMMAND_REFRESH = 'SEND_COMMAND_REFRESH',
  SEND_COMMAND_THRESHOLD = 'SEND_COMMAND_THRESHOLD',
  SEND_COMMAND_UNBLOCK = 'SEND_COMMAND_UNBLOCK',
  START_MAINTENANCE = 'START_MAINTENANCE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TOGGLE_ASSOCIATION = 'TOGGLE_ASSOCIATION',
  TOGGLE_CATALOGS = 'TOGGLE_CATALOGS',
  TOGGLE_COMMENTS = 'TOGGLE_COMMENTS',
  TOGGLE_DATA_GUARD = 'TOGGLE_DATA_GUARD',
  TOGGLE_DEVICES_SELECTION_FOR_SCHEDULER = 'TOGGLE_DEVICES_SELECTION_FOR_SCHEDULER',
  TOGGLE_FILTER_ENGINE = 'TOGGLE_FILTER_ENGINE',
  TOGGLE_PAGE_TYPE = 'TOGGLE_PAGE_TYPE',
  PENDING = 'PENDING',
  PUBLISH = 'PUBLISH',
  CREATE = 'CREATE',
  CREATE_SITE = 'CREATE_SITE',
  EDIT_SITE = 'EDIT_SITE',
  ADD_DEVICE = 'ADD_DEVICE',
  EDIT_DEVICE = 'EDIT_DEVICE',
  REPLACE_DEVICE = 'REPLACE_DEVICE',
  CREATE_ASSET = 'CREATE_ASSET',
  CREATE_ASSET_FROM_TEMPLATE = 'CREATE_ASSET_FROM_TEMPLATE',
  CREATE_ASSET_FROM_SCRATCH = 'CREATE_ASSET_FROM_SCRATCH',
  EDIT_ASSET = 'EDIT_ASSET',
  CREATE_VIA_FUNNEL = 'CREATE_VIA_FUNNEL',
  CREATE_FROM_TEMPLATE = 'CREATE_FROM_TEMPLATE',
  CREATE_ASSET_GROUP = 'CREATE_ASSET_GROUP',
  VIEW_BY_ASSET = 'VIEW_BY_ASSET',
  VIEW_BY_DEVICE = 'VIEW_BY_DEVICE',
  CLOSE = 'CLOSE',
  MANAGE_TOPIC_SUBSCRIPTIONS_ACTION = 'MANAGE_TOPIC_SUBSCRIPTIONS_ACTION',
  MANAGE_TOPIC_SUBSCRIBERS = 'MANAGE_TOPIC_SUBSCRIBERS',
  MANAGE_TOPIC_PROTOCOLS = 'MANAGE_TOPIC_PROTOCOLS',
  NAVIGATE_TO_FUNNEL = 'NAVIGATE_TO_FUNNEL',
  BACKDROP_CLICKED = 'backdropClicked',
  MANAGE_VARIABLES = 'MANAGE_VARIABLES',
  CREATE_VARIABLES_FROM_DEVICE = 'CREATE_VARIABLES_FROM_DEVICE',
  CREATE_VARIABLE_FROM_SCRATCH = 'CREATE_VARIABLE_FROM_SCRATCH',
  EDIT_VARIABLE = 'EDIT_VARIABLE',
  CONFIGURE_VARIABLE = 'CONFIGURE_VARIABLE',
  DELETE_VARIABLE = 'DELETE_VARIABLE',
  DELETE_DEVICE_VARIABLE = 'DELETE_DEVICE_VARIABLE',
  RESET_LAST_VALUE = 'RESET_LAST_VALUE',
  RESET_DEVICE_VARIABLE_LAST_VALUE = 'RESET_DEVICE_VARIABLE_LAST_VALUE',
  BREAK_FORMULA = 'BREAK_FORMULA',
  VIEW_VARIABLES = 'VIEW_VARIABLES',
  VIEW_DEVICE_VARIABLES_ASSOCIATION = 'VIEW_DEVICE_VARIABLES_ASSOCIATION',
  VIEW_ASSET_VARIABLES_ASSOCIATION = 'VIEW_ASSET_VARIABLES_ASSOCIATION',
  APPLY_TEMPLATE_TO_ASSET = 'APPLY_TEMPLATE_TO_ASSET'
}
